import React from "react";

import Container from "components/Container";

const Footer = () => {
  return (
    <footer>
      <Container>
        <p>
          &copy; {new Date().getFullYear()}, Alexander G.{" "}
          <a
            href="https://github.com/NovelCOVID/API"
            target="_blank"
            rel="noopener noreferrer"
          >
            COVID API
          </a>
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
